import { call, put, select } from "redux-saga/effects";
import { checkObd as checkObdAda } from "@bitComponents/adabyron/manager";

const contextStore = (state) => state.context.data;

export function* checkOBD(params) {
  const { reduxUpdate } = params;

  const { successUpdate } = reduxUpdate;
  const context = yield select(contextStore);
  const response = yield call(checkObdAda, context);

  if (successUpdate) {
    yield put(successUpdate(response));
  }

  return response;
}
